import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Inputs } from '../../../../Components';
import { VerifyApplicationUserCode } from '../../../../Services/LoginService';
import propxLogin from '../../../../assets/images/pages/login/propx-login.svg';
import { LoginFormsEnum } from './LoginFormsEnum';
import { ArrowLeftIcon } from '../../../../assets/icons';

export const OTPVerificationForm = ({
  setActiveLoginForm,
  userVerificationInfo,
  translationPath,
  parentTranslationPath,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [verificationCodeDigits, setVerificationCodeDigits] = useState({
    digit1: null,
    digit2: null,
    digit3: null,
    digit4: null,
  });

  const inputRefs = {
    digit1: useRef(null),
    digit2: useRef(null),
    digit3: useRef(null),
    digit4: useRef(null),
  };

  useEffect(() => {
    setTimeout(() => {
      const firstInput = inputRefs.digit1.current;
      if (firstInput?.querySelector) {
        const input = firstInput.querySelector('input');
        if (input) input.focus();
      }
    }, 300);
  }, []);

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    const digits = pastedData.replace(/\D/g, '').slice(0, 6).split('');

    const newDigits = {};
    digits.forEach((digit, index) => {
      const digitKey = `digit${index + 1}`;
      newDigits[digitKey] = digit;
    });

    setVerificationCodeDigits({
      ...verificationCodeDigits,
      ...newDigits,
    });
  };
  const handleOTPSubmit = async (event) => {
    event.preventDefault();

    const verificationCode = Object.values(verificationCodeDigits).reduce(
      (accumulator, item) => accumulator + item,
      ''
    );
    const response = await VerifyApplicationUserCode({
      identityVerificationId: +userVerificationInfo.identityVerificationId,
      code: verificationCode,
    });
    if (response) {
      setActiveLoginForm(LoginFormsEnum.ChangePassword.key);
    }
  };

  return (
    <div className='login-form-container'>
      <div className='login-header'>
        <img src={propxLogin} />
      </div>
      <h1 className='heading-1'>{t(`${translationPath}otp-heading`)}</h1>
      <h5 className='heading-2 mb-4'>
        <span>{t(`${translationPath}otp-description`)}</span>
        <span className='login-text-btn'>{userVerificationInfo.email}</span>
      </h5>
      <div className='login-form'>
        <form
          noValidate
          className='form-wrapper'
          onSubmit={handleOTPSubmit}
        >
          <div
            className='otp-container d-flex-v-center-h-between'
            onPaste={handlePaste}
          >
            {Object.keys(verificationCodeDigits).map((digitKey, index) => {
              const nextDigitKey = index < 4 ? `digit${index + 2}` : null;
              return (
                <Inputs
                  key={digitKey}
                  refs={inputRefs[digitKey]}
                  idRef={`OTP${index + 1}-Ref`}
                  wrapperClasses={`OTP-input ${
                    verificationCodeDigits[digitKey] ? 'filled' : ''
                  }`}
                  inputPlaceholder={t(`${translationPath}zero`)}
                  value={verificationCodeDigits[digitKey]}
                  onInputChanged={(event) => {
                    const newValue = event.target.value;
                    const lastChar = newValue.slice(-1);

                    if (!isNaN(lastChar) && lastChar !== ' ') {
                      setVerificationCodeDigits((prevState) => ({
                        ...prevState,
                        [digitKey]: lastChar,
                      }));

                      if (
                        lastChar &&
                        nextDigitKey &&
                        inputRefs[nextDigitKey].current
                      ) {
                        setTimeout(() => {
                          const nextInput =
                            inputRefs[nextDigitKey].current.querySelector(
                              'input'
                            );
                          if (nextInput) {
                            nextInput.focus();
                            nextInput.select();
                          }
                        }, 50);
                      }
                    } else if (newValue === '') {
                      setVerificationCodeDigits((prevState) => ({
                        ...prevState,
                        [digitKey]: '',
                      }));
                    }
                  }}
                  onKeyDown={(event) => {
                    if (
                      event.key === 'Backspace' &&
                      !verificationCodeDigits[digitKey] &&
                      index > 0
                    ) {
                      event.preventDefault();
                      const prevDigitKey = `digit${index}`;
                      const prevInput = inputRefs[prevDigitKey].current;
                      if (prevInput) {
                        const input = prevInput.querySelector('input');
                        if (input) {
                          input.focus();
                          input.select();
                        }
                      }
                    }
                  }}
                  maxLength={1}
                  type='text'
                  inputMode='numeric'
                  pattern='[0-9]'
                />
              );
            })}
          </div>
          <div className='d-flex-column-center'>
            <Button
              className='login-btn'
              type='submit'
            >
              {<span>{t(`${translationPath}Verify-OTP`)}</span>}
            </Button>
          </div>
          <div
            className='back-to-login'
            onClick={() => setActiveLoginForm(LoginFormsEnum.SignIn.key)}
          >
            <ArrowLeftIcon
              width={20}
              height={20}
              fill={'#475467'}
              className='back-to-login-icon'
            />
            <span className='back-to-login-text'>
              {t(`${translationPath}back-to-login`)}
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};
